import type { LandingBlockProps } from '@features/landing-page-builder/model/blockRegistry'

import styles from './LandingPartnersBlock.module.scss'

/*
  partners: a logo wall. Logos come inline from payload.items; the contest-backed
  source (payload.source === 'contest_partners') is a promo-landing feature this
  site has no contest pages for, so it renders nothing rather than a broken grid.
*/
interface PartnerItem {
  image?: string;
  name?: string;
}

interface PartnersPayload {
  title?: string;
  items?: PartnerItem[];
  source?: string;
}

export default function LandingPartnersBlock ({ payload }: LandingBlockProps) {
  const { title, items, source } = (payload ?? {}) as PartnersPayload

  if (source === 'contest_partners') {
    return null
  }

  const partners = (items ?? []).filter((item) => item?.image || item?.name)

  if (partners.length === 0) {
    return null
  }

  return (
    <section className={styles.root}>
      {title && <h2 className={styles.root__title}>{title}</h2>}

      <div className={styles.root__grid}>
        {partners.map((partner, index) => (
          <div className={styles.logo} key={index}>
            {partner.image ? (
              <img
                className={styles.logo__image}
                src={partner.image}
                alt={partner.name ?? ''}
                loading="lazy"
              />
            ) : (
              <span className={styles.logo__name}>{partner.name}</span>
            )}
          </div>
        ))}
      </div>
    </section>
  )
}
